import React from 'react'
import { Mutation } from "react-apollo";
import Form from "../components/form";
import { ADD, GET } from "../../../queries/user";
import { ADD_EDIT_ACCESS } from "../../../queries/access";
import { ADD_EDIT_NETWORK_USER_ACCESS } from "../../../queries/userNetworks";

const Add = (props) => {
  return (
    <Mutation
      mutation={ADD}
      update={(store, { data: { createUser } }) => {
        const { users } = store.readQuery({ query: GET });
        store.writeQuery({
          query: GET,
          data: { users: users.concat([createUser]) }
        });
      }}
      >
        {createUser => (
        <Mutation mutation={ADD_EDIT_ACCESS} update={(store, { data: { createUser } }) => {}}>
          {createAccess=> (
            <Mutation mutation={ADD_EDIT_NETWORK_USER_ACCESS} update={(store, { data: { createUserNetwork } }) => {}}>
            {createUserNetwork=> (
                <Form query_f = {createUser} query_access={createAccess} query_userNetworks={createUserNetwork} {...props} />
            )}
            </Mutation>
          )}
        </Mutation>
        )}
    </Mutation>
  );
};

export default Add;